import { createApp } from 'vue'
import App from './App.vue'
import {router} from "@/config/router.js";

import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import '@/lib/css/base.css'
import '@/lib/bootstrap/bootstrap_icon_341.css'

// 初始化leaflet的地图加载
import {initLeafChinaProvider} from "@/lib/map/leaflet/leaflet.ChineseTmsProviders";




import {setupModal} from "@/lib/modal/index.js";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


function createVue(rootCom,z){
  const vueApp = createApp(rootCom)
  vueApp.use(ElementPlus,{
    // size: 'small',
    locale: zhCn,
    zIndex: z
  })
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    vueApp.component(key, component)
  }
  return vueApp
}

setupModal(createVue)

// 页面element组件的indexZ
const app = createVue(App,3000)

app.use(router)
app.mount('#app')
